import { useCallback, useEffect, useRef, useState } from "react";

import { sortByField } from "../../utils/Sort";

import "./KochLocationFilter.css";
import NitroFilter from "../NitroFilter";
import { OccupantsIcon } from "../../icons";
import NitroService from "../../utils/nitro.service";
import LoadingIcon from "../Loading";

const OccupantFilter = ({
  locationId,
  value,
  setValue,
  setOccupantList,
  config,
  disabled,
  isMobile,
}: {
  locationId: string;
  value?: { id: string; name: string };
  setValue: (value: { id: string; name: string }) => void;
  setOccupantList?: (occupants: { id: string; name: string }[]) => void;
  config?: {
    customPaper?: boolean;
    shadow?: boolean;
    opaque?: boolean;
    autoFocus?: boolean;
    inputRef?: React.MutableRefObject<any> | null;
    valueRequired?: boolean;
  };
  disabled?: boolean;
  isMobile?: boolean;
}) => {
  const ref = useRef<any>();

  const [options, setOptions] = useState<{ id: string; name: string }[]>([
    { id: "", name: "" },
  ]);

  const [isLoading, setIsLoading] = useState(false);

  const load = useCallback(async () => {
    if (!locationId) return setOptions([]);

    setIsLoading(true);

    try {
      const records: any[] = await NitroService.getOccupantsByLocationId({
        locationId,
      });

      const sorted = [
        { id: "", name: "" },
        ...sortByField(records, "name", "ASC"),
      ];

      setOptions(sorted);
      if (setOccupantList) {
        setOccupantList(sorted);
      }

      // This state update in the parent component is what triggers a useEffect hook
      // RouteValidation/index.tsx and navigate to the next panel (i.e., "TASK_LIST").
      if (records.length === 1) {
        setValue(records[0]);
      } else if (records.length > 1) {
        // The dropdown menu displays when there are more than one record because the automatic
        // selection logic is only triggered for a single record. When multiple records are found,
        // the component proceeds to its default behavior, which is to render the full list of options
        //  for the user to choose from.
        // ref.current.focus();
      }
    } catch (err) {
      console.log(err);
    }

    setIsLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationId]);

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationId]);

  if (isLoading) {
    return <LoadingIcon color="#005CA6" height={60} width={60} />;
  }

  return (
    <NitroFilter
      disabled={disabled}
      placeholder="Occupant"
      size="small"
      data={{
        options: options.map((r) => {
          return { label: r.name || "", value: r.name };
        }),
      }}
      value={value?.name || ""}
      setValue={(name) => {
        const match = options.find((o) => o.name === name);
        if (match) {
          return setValue(match);
        }
        return setValue({ id: "", name: "" });
      }}
      isMobile={isMobile}
      config={{
        ...config,
        inputRef: ref,
        autoFocus: true,
        valueRequired: false,
      }}
      Icon={<OccupantsIcon color="#383838" />}
    />
  );
};

export default OccupantFilter;
